import { Textarea } from "@/components/ui/textarea"
import { Button } from "@/components/ui/button"
import { Dispatch, SetStateAction, useState } from "react"
import { useToast } from "../ui/use-toast"
import { useSession } from "next-auth/react"
import { useRouter } from "next/router"
import { fetchApi } from "@/lib/utils"
import { ClipLoader } from "react-spinners"

interface Props {
  commentId: string,
  commentBody: string,
  articleId: number,
  refreshComments: () => void,
  setCommentId: Dispatch<SetStateAction<string>>,
  setCommentBody: Dispatch<SetStateAction<string>>
}
const SendCommentaire = ({commentId, commentBody, articleId, setCommentId, setCommentBody, refreshComments}: Props) => {
    const [comment, setComment] = useState("")
    const {toast} = useToast()
    const { status, data } = useSession()
    const router = useRouter()
    const [loading, setLoading] = useState(false)
    
    const navigateTo = () => {
      router.push({ pathname: '/m-identifier' })
    }
    const submit = async (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      setLoading(true)
      try {
        const body = {
          "comment_type": [{"target_id": "defaut"}],
          "entity_type": [{"value": "node"}],
          "entity_id": [{"target_id": articleId}],
          "field_name": [{"value": "field_commentaires"}],
          "subject": [{"value": "Comment"}],
          "comment_body": [{
            "value": comment, 
            "format": "html"
          }],
        }
        if (commentId && commentId !== '') {
          body["pid"] = [{"target_id": commentId}]
        }

        const getOptions: RequestInit = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${data?.accessToken}`
          },
          body: JSON.stringify(body),
        }

        const response = await fetchApi(`/api/post-comment`, getOptions)
        if (response) {
          setComment("")
          resetReply()
          refreshComments()
          toast({title: "Votre commentaire a été ajouté"})
        } else {
          toast({title: "Veuillez vous connecter pour commenter"})
        }
 
      } catch (error) {
        toast({title: "il y a eu une erreur"})
        console.error('Failed to post comment:', error)
      }
      setLoading(false)
    }
    const resetReply = () => {
      setCommentId('')
      setCommentBody('')
    }
    return (
      <form className="flex justify-center flex-col my-5">
        {commentId && commentId !== '' && (
          <div className="mb-5 flex items-center gap-2">
            <span className="text-gray-600">
              Réponse à &quot;{commentBody.length > 20 ? commentBody.substring(0, 20) + '...' : commentBody}&quot;
            </span>
            <button 
              className="inline-flex items-center px-3 py-1 text-sm text-blue-600 hover:text-blue-700 hover:bg-red-50 rounded-md transition-colors duration-200"
              onClick={resetReply}
            >
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-4 w-4 mr-1" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M6 18L18 6M6 6l12 12" 
                />
              </svg>
              Arrêter de répondre
            </button>
          </div>
        )}
        <Textarea 
          placeholder="Rédiger un commentaire..." 
          className="w-full mb-5"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        <div className="text-center">
          {loading ?
            <ClipLoader />
          :
            <>
              {status === "authenticated" ?
                <Button type="button" onClick={submit}>
                  Envoyer le commentaire
                </Button>
                :
                <Button type="button" onClick={navigateTo}>
                  Se connecter et réagir
                </Button>
              }
            </>
          }
        </div>
      </form>
    )
}

export default SendCommentaire